import { Fragment } from "react";

import { ReactComponent as MarkerPinIcon } from "assets/images/iconsV2/marker-pin-02.svg";
import { formatDatetime } from "helpers/commonHelpers";
import { DateTimeFormat } from "helpers/dateTimeHelper";
import { getFreightModeIcon } from "helpers/freightModeHelper";
import { formatScheduleArray } from "pages/shipper/ShipmentQuotes/components/quotes/quotesColumns";
import { IQuotation } from "pages/shipper/ShipmentQuotes/components/quotes/QuotesType";

type QuoteDetailRouteStopsProps = {
  currentQuotation: IQuotation;
};

function QuoteDetailRouteStops(props: QuoteDetailRouteStopsProps) {
  const { currentQuotation } = props;

  const Icon = getFreightModeIcon(
    currentQuotation.service.freight_mode_label,
    currentQuotation.service.freight_mode_type,
    true,
  );

  const stops = formatScheduleArray(currentQuotation.schedule).filter(
    (stop) => !["Pickup date", "Delivery date"].includes(stop.label),
  );

  return (
    <div className="d-flex align-items-center">
      <div className="position-relative">
        <MarkerPinIcon />
        <div className="pickup-container">
          <div className="text-sm font-medium font-black">Pickup</div>
          <div className="text-sm text-tertiary">
            {formatDatetime(currentQuotation.schedule.quoted_pickup_date, DateTimeFormat.shortDateTimeFormat)}
          </div>
        </div>
      </div>
      <div className="route-line">
        <div className="route-line-sub-container">
          {stops.length > 0 &&
            stops.map((item: any, index: number) => (
              <Fragment key={item.label}>
                {index !== 0 && (
                  <div className="route-line-icon">
                    <Icon
                      style={{
                        height: "20px",
                      }}
                    />
                  </div>
                )}
                <div className="route-line-item">
                  <div className="route-line-item-content text-sm font-medium font-black">{item.labelV2 || item.label}</div>
                </div>
              </Fragment>
            ))}
          {stops.length === 0 && (
            <div className="route-line-icon">
              <Icon
                style={{
                  height: "20px",
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div className="position-relative">
        <MarkerPinIcon />
        <div className="delivery-container">
          <div className="text-sm font-medium font-black">Delivery</div>
          <div className="text-sm text-tertiary">
            {formatDatetime(currentQuotation.schedule.quoted_time_delivery_date, DateTimeFormat.shortDateTimeFormat)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuoteDetailRouteStops;
